import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Render text with @mentions styled as blue links to /profile/<id>.
 * Mentions is an array of {id, name}.
 */
export function renderMentions(text, mentions = []) {
  if (!text) return null;
  if (!mentions || mentions.length === 0) {
    return text;
  }

  // Sort by name length desc so longer names are matched first
  const sorted = [...mentions].sort((a, b) => b.name.length - a.name.length);

  // Build a single regex with capture groups for each mention name
  const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const pattern = new RegExp(`@(${sorted.map((m) => escape(m.name)).join('|')})`, 'g');

  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const name = match[1];
    const mention = sorted.find((m) => m.name === name);
    parts.push(
      <Link
        key={`m-${key++}`}
        to={`/profile/${mention.id}`}
        className="font-semibold text-[#1E3A8A] hover:underline"
      >
        @{name}
      </Link>
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}
